import genericUserImage from '../images/generic-user-avatar.png';
import styled, { css } from 'styled-components';


const styles = css`
text-align: 'center';
display: flex;
padding: 5px;
height: 100%;
width: 100%;

img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
  aspect-ratio: 1/1;
}

`;
const Avatar = styled(({ className, src, width, title, defaultImage = genericUserImage }) => {
  const widthQuery = width ? `?w=${width}` : '';
  return (
    <div className={className}>
      <img height='100%' width='100%' src={src ? `${src}${widthQuery}` : defaultImage} title={title} alt='avatar for user' />
    </div>
  )
})`${styles}`;
export default Avatar;